import React, { Component } from 'react';
import copy from 'clipboard-copy';
import { notify } from 'react-notify-toast';
import { withRouter } from 'react-router-dom';
import { Button, DialogModalWindow } from 'src/components/shared'

export class Subtitle extends Component {

  render() {
    const { text, color = 'red' } = this.props

    return (
      <span style={{ color }} className='prioritize__header-step' >
        {text}
      </span>
    )
  }
}

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShareDialogOpen: false
    };
  }

  onShareUrlClick = () => {
    copy(window.location.href)
      .then(() => {
        notify.show('Copied share link to clipboard!', 'success', 1000);
      }).catch(() => {
        notify.show('Failed to copy share link to clipboard!', 'warning', 1000)
      });
  }

  render() {
    const { children, hasNav } = this.props
    const { isShareDialogOpen } = this.state

    return (
      <div className={`prioritize__header ${hasNav ? 'has-nav' : 'no-nav'}`}>

        {children}

        <DialogModalWindow
          isOpen={isShareDialogOpen}
          title={'Copy and share this link to spread the word'}
          onCancel={() => this.setState({ isShareDialogOpen: false })}
          cancelBtn={false}
          confirmBtn={false}
        >
          <div className="share">
            <div className="url" onClick={this.onShareUrlClick}>{window.location.href}</div>
            <Button className="btn-primary" onClick={this.onShareUrlClick}>Copy</Button>
          </div>
          <small>Anyone inside and/or outside your organization can access your POPin with this link</small>
        </DialogModalWindow>

      </div>
    )
  }
}

export default withRouter(Header);
